export default __webpack_public_path__ + "static/media/video.729cfb8d.mp4";